import { render, staticRenderFns } from "./sendMsgForm.vue?vue&type=template&id=4efb1228&scoped=true&"
import script from "./sendMsgForm.vue?vue&type=script&lang=js&"
export * from "./sendMsgForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb1228",
  null
  
)

export default component.exports